module.exports = __webpack_public_path__ + "img/c-case2.d14276cb.png";